// Add education by copying this template:
// {
//   id: 1,
//   institution: "University Name",
//   degree: "Degree Name",
//   location: "City, State",
//   startDate: "Aug 2024",
//   endDate: "Present",
//   current: true,
//   coursework: ["Course 1", "Course 2"]
// }

const education = [
  {
    id: 1,
    institution: "University of Illinois at Chicago",
    degree: "Master of Science in Computer Science",
    location: "Chicago, IL",
    startDate: "Aug 2024",
    endDate: "May 2026",
    current: true,
    coursework: [
      "Advanced Machine Learning",
      "Cloud Computing",
      "Secure Web Application Development",
      "Responsible AI Engineering",
      "Security and Privacy in Networked and Distributed Systems",
      "Natural Language Processing"
    ]
  },
  {
    id: 2,
    institution: "SRM Institute of Science and Technology",
    degree: "Bachelor of Technology in Computer Science Engineering",
    location: "Chennai, India",
    startDate: "Sep 2020",
    endDate: "May 2024",
    current: false,
    coursework: [
      "Artificial Intelligence",
      "Database Management Systems",
      "Cloud Native Architecture"
    ]
  }
];

export default education;
